/**
 * @generated SignedSource<<3cc8d4ee7d99a0992122a56f21f2c656>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedDashboardBlockCardViewQuery$variables = {
  after?: string | null;
  blockId: string;
  dashboardId: string;
  first?: number | null;
};
export type FeedDashboardBlockCardViewQuery$data = {
  readonly feedBlock: {
    readonly posts: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"PostCardFragment">;
        };
      }>;
      readonly totalCount: number;
    };
  } | null;
};
export type FeedDashboardBlockCardViewQuery = {
  response: FeedDashboardBlockCardViewQuery$data;
  variables: FeedDashboardBlockCardViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "blockId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dashboardId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = [
  {
    "kind": "Variable",
    "name": "blockId",
    "variableName": "blockId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "dashboardId",
    "variableName": "dashboardId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfoObjectType",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v12 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releasedAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v15 = [
  (v14/*: any*/)
],
v16 = {
  "kind": "InlineFragment",
  "selections": (v15/*: any*/),
  "type": "Organization",
  "abstractKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "nonNullProductId",
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v14/*: any*/),
    (v17/*: any*/)
  ],
  "type": "Product",
  "abstractKey": null
},
v19 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v14/*: any*/),
  (v17/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "Event",
  "abstractKey": null
},
v21 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v14/*: any*/),
  (v17/*: any*/)
],
v22 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "Comment",
  "abstractKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "Feed",
  "abstractKey": null
},
v24 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "Post",
  "abstractKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "nullableProductIdString",
      "args": null,
      "kind": "ScalarField",
      "name": "productId",
      "storageKey": null
    },
    (v14/*: any*/),
    (v17/*: any*/)
  ],
  "type": "ContentUsage",
  "abstractKey": null
},
v26 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "ChatChannel",
  "abstractKey": null
},
v27 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "Dashboard",
  "abstractKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "AssignmentSubmission",
  "abstractKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": (v15/*: any*/),
  "type": "PathwayGroup",
  "abstractKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": (v15/*: any*/),
  "type": "BrainSearch",
  "abstractKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v34 = [
  (v6/*: any*/),
  (v33/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "avatar",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isTest",
    "storageKey": null
  }
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v36 = [
  (v6/*: any*/),
  (v31/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedDashboardBlockCardViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "FeedDashboardBlock",
        "kind": "LinkedField",
        "name": "feedBlock",
        "plural": false,
        "selections": [
          {
            "alias": "posts",
            "args": null,
            "concreteType": "PostNodeConnection",
            "kind": "LinkedField",
            "name": "__FeedDashboardBlockCardView__posts_connection",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PostNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Post",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "args": (v7/*: any*/),
                        "kind": "FragmentSpread",
                        "name": "PostCardFragment"
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FeedDashboardBlockCardViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "FeedDashboardBlock",
        "kind": "LinkedField",
        "name": "feedBlock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v12/*: any*/),
            "concreteType": "PostNodeConnection",
            "kind": "LinkedField",
            "name": "posts",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PostNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Post",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "feedId",
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Feed",
                        "kind": "LinkedField",
                        "name": "feed",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v16/*: any*/),
                              (v18/*: any*/),
                              (v20/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v30/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "coverVideo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AssetUsage",
                            "kind": "LinkedField",
                            "name": "coverVideoAssetUsage",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Asset",
                                "kind": "LinkedField",
                                "name": "asset",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                  },
                                  (v31/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "muxAssetPlaybackId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "aspectRatio",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "videoDuration",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "coverPhoto",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbnailUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showCoverPlayIcon",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": (v34/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/),
                              (v35/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "releaseDatetime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "creationDatetime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Post",
                            "kind": "LinkedField",
                            "name": "post",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Feed",
                                "kind": "LinkedField",
                                "name": "feed",
                                "plural": false,
                                "selections": (v36/*: any*/),
                                "storageKey": null
                              },
                              (v13/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "richEditorDescriptionContent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentMentionNodeConnection",
                            "kind": "LinkedField",
                            "name": "mentions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentMentionNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentMention",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v33/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MemberGroup",
                                        "kind": "LinkedField",
                                        "name": "memberGroup",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v31/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "kind",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "role",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Product",
                                        "kind": "LinkedField",
                                        "name": "mentionedProduct",
                                        "plural": false,
                                        "selections": (v36/*: any*/),
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsage",
                                        "kind": "LinkedField",
                                        "name": "mentionedContentUsage",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": (v36/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Occurrence",
                                        "kind": "LinkedField",
                                        "name": "mentionedOccurrence",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v31/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                              (v31/*: any*/),
                                              (v6/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentAttachmentNodeConnection",
                            "kind": "LinkedField",
                            "name": "attachments",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentAttachmentNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentAttachment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v31/*: any*/),
                                      (v32/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "downloadUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "videoUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mediaUrl",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasViewerBookmarked",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showComments",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentLikeNodeConnection",
                            "kind": "LinkedField",
                            "name": "likes",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentReactionConnection",
                            "kind": "LinkedField",
                            "name": "uniqueReactions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentReactionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentReaction",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasViewerReacted",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "emojiCode",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "emojiAlias",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "emojiCount",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalComments",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasViewerCommented",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "viewerHasFlagged",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentFlaggingNodeConnection",
                            "kind": "LinkedField",
                            "name": "flaggings",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentFlaggingNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentFlagging",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "reason",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "reasonText",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "createdAt",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "User",
                                        "kind": "LinkedField",
                                        "name": "user",
                                        "plural": false,
                                        "selections": (v34/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v35/*: any*/),
                          (v31/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v7/*: any*/),
                        "concreteType": "PinnedPost",
                        "kind": "LinkedField",
                        "name": "pinnedPost",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ordering",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          (v18/*: any*/),
                          (v20/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v12/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "FeedDashboardBlockCardView__posts",
            "kind": "LinkedHandle",
            "name": "posts"
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a97dbb42af941b75b4f4ef664a73d2fb",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "feedBlock",
            "posts"
          ]
        }
      ]
    },
    "name": "FeedDashboardBlockCardViewQuery",
    "operationKind": "query",
    "text": "query FeedDashboardBlockCardViewQuery(\n  $blockId: ID!\n  $dashboardId: ID!\n  $first: Int\n  $after: String\n) {\n  feedBlock(blockId: $blockId) {\n    posts(first: $first, after: $after) {\n      totalCount\n      edges {\n        node {\n          id\n          ...PostCardFragment_3DRocR\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment BookmarkButtonContentFragment on Content {\n  id\n  hasViewerBookmarked\n}\n\nfragment CommentUtils_useTotalCommentsCount on Content {\n  totalComments\n}\n\nfragment ContentAttachmentsSectionFragment on Content {\n  attachments {\n    edges {\n      node {\n        id\n        name\n        type\n        downloadUrl\n        videoUrl\n        mediaUrl\n      }\n    }\n  }\n}\n\nfragment ContentCard_ContentFragment on Content {\n  id\n  coverVideo\n  coverVideoAssetUsage {\n    id\n    asset {\n      id\n      ...DiscoVideoFragment\n    }\n  }\n  coverPhoto\n  thumbnailUrl\n  showCoverPlayIcon\n  ...ContentHeaderSectionFragment\n  ...ContentMediaSectionFragment\n  ...ContentTitleSectionFragment\n  ...ContentDescriptionSectionFragment\n  ...ContentAttachmentsSectionFragment\n  ...ContentFooterSection_ContentFragment\n  ...BookmarkButtonContentFragment\n}\n\nfragment ContentCommentButton_ContentFragment on Content {\n  ...CommentUtils_useTotalCommentsCount\n  hasViewerCommented\n}\n\nfragment ContentDescriptionSectionFragment on Content {\n  id\n  richEditorDescriptionContent\n  type\n  ...DiscoEditorMentionsFragment\n}\n\nfragment ContentFlaggingListItemFragment on ContentFlagging {\n  id\n  reason\n  reasonText\n  createdAt\n  user {\n    id\n    ...ProfileAvatarWithDetailsFragment\n  }\n}\n\nfragment ContentFlaggingListPopoverFragment on Content {\n  flaggings {\n    edges {\n      node {\n        id\n        ...ContentFlaggingListItemFragment\n      }\n    }\n  }\n}\n\nfragment ContentFlaggingsChipFragment on Content {\n  flaggings {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  ...ContentFlaggingListPopoverFragment\n}\n\nfragment ContentFooterSection_ContentFragment on Content {\n  id\n  hasViewerBookmarked\n  showComments\n  ...ContentReactionButton_ContentFragment\n  ...ContentCommentButton_ContentFragment\n  ...BookmarkButtonContentFragment\n}\n\nfragment ContentHeaderSectionFragment on Content {\n  id\n  type\n  createdBy {\n    id\n    ...ProfileAvatarWithDetailsFragment\n  }\n  product {\n    name\n    slug\n    id\n  }\n  releaseDatetime\n  creationDatetime\n  post {\n    feed {\n      id\n      name\n    }\n    releasedAt\n    id\n  }\n}\n\nfragment ContentMediaSectionFragment on Content {\n  id\n  coverPhoto\n  coverVideo\n  coverVideoAssetUsage {\n    id\n    asset {\n      id\n      ...DiscoVideoFragment\n    }\n  }\n}\n\nfragment ContentReactionButton_ContentFragment on Content {\n  id\n  likes {\n    totalCount\n  }\n  uniqueReactions {\n    edges {\n      node {\n        id\n        hasViewerReacted\n        emojiCode\n        emojiAlias\n        emojiCount\n      }\n    }\n  }\n}\n\nfragment ContentTitleSectionFragment on Content {\n  id\n  name\n}\n\nfragment DeletePostButtonFragment on Post {\n  id\n  feedId\n  ...usePermissionsFragment\n}\n\nfragment DiscoEditorMentionsFragment on Content {\n  id\n  ...EditorMentionsProviderFragment\n}\n\nfragment DiscoVideoFragment on Asset {\n  id\n  url\n  name\n  muxAssetPlaybackId\n  aspectRatio\n  videoDuration\n}\n\nfragment EditPostButtonFragment on Post {\n  id\n  ...usePermissionsFragment\n}\n\nfragment EditorMentionsProviderFragment on Content {\n  id\n  mentions {\n    edges {\n      node {\n        id\n        user {\n          id\n          fullName\n        }\n        memberGroup {\n          id\n          name\n          kind\n          role\n        }\n        mentionedProduct {\n          id\n          name\n        }\n        mentionedContentUsage {\n          id\n          content {\n            id\n            name\n          }\n        }\n        mentionedOccurrence {\n          id\n          name\n          content {\n            name\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment FlagContentButtonFragment on Content {\n  ...useCanFlagContentFragment\n  ...FlagContentFormFragment\n}\n\nfragment FlagContentFormFragment on Content {\n  id\n  type\n  product {\n    id\n  }\n}\n\nfragment PostCardFragment_3DRocR on Post {\n  id\n  feedId\n  releasedAt\n  feed {\n    ...usePermissionsFragment\n    id\n  }\n  content {\n    id\n    name\n    type\n    ...ContentCard_ContentFragment\n    ...FlagContentButtonFragment\n    ...ContentFlaggingsChipFragment\n    ...useCanFlagContentFragment\n  }\n  product {\n    id\n    slug\n    name\n    status\n  }\n  pinnedPost(dashboardId: $dashboardId) {\n    id\n    ordering\n  }\n  ...usePermissionsFragment\n  ...EditPostButtonFragment\n  ...DeletePostButtonFragment\n  ...SharePostButtonFragment\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n\nfragment ProfileAvatarWithDetailsFragment on User {\n  id\n  fullName\n  ...ProfileAvatarFragment\n}\n\nfragment SharePostButtonFragment on Post {\n  id\n  releasedAt\n  ...usePermissionsFragment\n}\n\nfragment useCanFlagContentFragment on Content {\n  viewerHasFlagged\n  createdBy {\n    id\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "a58c3066c8ed22588850134bf6b05e14";

export default node;
